import React from 'react';

interface ToggleProps {
  checked: boolean;
  onChange: (checked: boolean) => void;
  label?: string;
  disabled?: boolean;
  size?: 'sm' | 'md' | 'lg';
}

export const Toggle: React.FC<ToggleProps> = ({
  checked,
  onChange,
  label,
  disabled = false,
  size = 'md',
}) => {
  const sizes = {
    sm: { container: 'w-8 h-4', thumb: 'w-3 h-3', translate: 'translate-x-4' },
    md: { container: 'w-11 h-6', thumb: 'w-5 h-5', translate: 'translate-x-5' },
    lg: { container: 'w-14 h-7', thumb: 'w-6 h-6', translate: 'translate-x-7' },
  };

  return (
    <div className="flex items-center">
      <button
        type="button"
        className={`${sizes[size].container} ${
          checked ? 'bg-blue-600' : 'bg-gray-200'
        } relative inline-flex flex-shrink-0 border-2 border-transparent rounded-full cursor-pointer transition-colors duration-200 ease-in-out focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500 focus:ring-offset-gray-100 ${
          disabled ? 'opacity-50 cursor-not-allowed' : ''
        }`}
        onClick={() => !disabled && onChange(!checked)}
        disabled={disabled}
      >
        <span
          className={`${sizes[size].thumb} ${
            checked ? sizes[size].translate : 'translate-x-0'
          } pointer-events-none inline-block rounded-full bg-white shadow-lg transform ring-0 transition duration-200 ease-in-out`}
        />
      </button>
      {label && (
        <span className="ml-3 text-sm font-medium text-gray-300">{label}</span>
      )}
    </div>
  );
};